import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCrypt} from "../../TheCrypt";
import {gsap} from "gsap";

export class CollapsePresentation implements SimplePresentation {
    name: string = "CollapseAndFillPresentation";

    shouldRun(): boolean {
        return TheCrypt.model.isNextRespin && !TheCrypt.model.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => controller.setSkipCallback());
        tl.add(TheCrypt.realArea.collapse());
        tl.add(() => controller.finish(), 0.1);
        tl.to(this, {duration: 0.01});

    }
}